






































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["alias", "supply", "height", "isListed", "token"]),
    ...mapGetters("currency", ["name", "rate", "symbol"]),
  },
})
export default class ContentHeader extends Vue {
  private alias: string;
  private supply: string;
  private height: number;
  private name: string;
  private rate: number;
  private symbol: string;
  private isListed: boolean;
  private token: string;

  get showMarketCap() {
    return this.isListed && this.token !== this.name;
  }
}
